import { QueryClient } from "@tanstack/react-query";

export const queryClientPayfac = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 3,
      staleTime: 1000 * 60 * 10,
      refetchInterval: 1000 * 60 * 60,
    },
  },
});
